/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CalendarDisplayItem {
  EMPLOYEES = 'employees',
  CUSTOMER_NAME = 'customer_name',
  ORDER_NUMBER = 'order_number',
  CHECKIN_TIME = 'checkin_time',
  EVENT_NAME = 'event_name',
  LOCATION = 'location',
  CUSTOM_DETAILS = 'custom_details',
}
